import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { ChevronRight } from 'lucide-react';
import { LogoGraphic } from './common/LogoGraphic';

const NAV_ITEMS = ['HOME', 'ABOUT', 'SKILLS', 'PROJECTS', 'EXPERIENCE', 'EDUCATION', 'CONTACT'];

const NavbarImpl = ({
  accent,
  activePage,
  navigate,
  navRefs,
  reducedMotion,
  magnetX,
  magnetY,
  onMagnetMove,
  onMagnetReset,
  playIgnition,
  playClick,
}) => {
  const connectRef = useRef(null);

  return (
    <motion.nav className="fixed top-0 left-0 w-full z-50 px-4 sm:px-8 py-4 flex justify-between items-center">
      <div className="flex items-center gap-5 cursor-pointer group" onClick={() => navigate('HOME', 0)}>
        <motion.div layoutId="main-logo" className="w-12 h-12 flex items-center justify-center transition-all group-hover:scale-110">
          <LogoGraphic accentColor={accent.color} className="w-10 h-10" />
        </motion.div>
        <div className="hidden sm:block">
          <h1 className="text-md font-black italic uppercase leading-tight tracking-tighter">NiKHiL</h1>
          <p className="text-[10px] uppercase font-black text-white/20 tracking-widest">FULL STACK DEVELOPER</p>
        </div>
      </div>
      <div className="relative mx-4 md:mx-0 max-w-[60vw] md:max-w-full overflow-hidden">
        <div
          className="
            flex gap-8 lg:gap-14
            overflow-x-auto
            scrollbar-hide
            snap-x snap-mandatory
            whitespace-nowrap
            overscroll-x-contain
          "
          style={{
            WebkitOverflowScrolling: "touch",
            touchAction: "pan-x"
          }}
        >

        {NAV_ITEMS.map((item, idx) => (
          <button key={item} ref={(el) => (navRefs.current[item] = el)} onClick={() => navigate(item, idx)} className={`text-[11px] shrink-0 snap-start font-black tracking-[0.4em] uppercase transition-all relative py-3 ${activePage === item ? 'text-white' : 'text-white/20 hover:text-white'}`}>{item}
            {activePage === item && <motion.div layoutId="navUnderline" className="absolute bottom-0 left-0 w-full h-[3px]" style={{ backgroundColor: accent.color }} />}
          </button>
        ))}
        </div>
      </div>
        <motion.button
          ref={connectRef}
          style={{ x: reducedMotion ? 0 : magnetX, y: reducedMotion ? 0 : magnetY }}
          animate={reducedMotion ? {} : {
            boxShadow: [
              `0 0 0px ${accent.color}`,
              `0 0 22px ${accent.color}`,
              `0 0 0px ${accent.color}`,
            ],
            scale: [1, 1.03, 1],
          }}
          transition={{
            duration: 2.4,
            repeat: Infinity,
            ease: "easeInOut",
          }}
          onMouseMove={(e) => onMagnetMove(e, connectRef)}
          onMouseLeave={onMagnetReset}
          onHoverStart={() => playIgnition(4)}
          className="flex items-center gap-3 px-4 sm:px-8 py-2 sm:py-3 rounded-sm border border-white/10 text-[9px] sm:text-[10px] font-black uppercase hover:bg-white hover:text-black transition-all group tracking-[0.2em]"
          onClick={() => {
            playClick();
            navigate('CONTACT', 6);
          }}
        >
          CONNECT
          <motion.span
            className="inline-flex"
            whileHover={{ x: 6 }}
          >
            <ChevronRight size={14} />
          </motion.span>
        </motion.button>

        <div className="pointer-events-none absolute left-0 top-0 h-full w-10 bg-gradient-to-r from-black to-transparent md:hidden" />
        <div className="pointer-events-none absolute right-0 top-0 h-full w-10 bg-gradient-to-l from-black to-transparent md:hidden" />

    </motion.nav>
  );
};

export const Navbar = React.memo(NavbarImpl);
